import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

LocalDate.propTypes = {
  value: PropTypes.any,
};

export default function LocalDate(props) {
  const date = props.value && new Date(props.value);
  return props.value ? (
    <span title={new Intl.DateTimeFormat('en-US', props).format(date)}>
      <FormattedDate {...props} />
    </span>
  ) : null;
}
